<template>
    <div class="banner">
        <div class="banner-container">
            <div class="banner_img">
                <img src="@/assets/VictoriaHarbourSunrise.jpg" alt="banner image">
                <div class="mask"></div>
                <div class="banner_content">
                    <div>
                        <p>ICA Regional Cartographic Conference</p>
                        <h1>The First Asian Cartographic Conference<br>AsiaCarto 2024</h1>
                        <div class="info-box">
                            <p><ClockCircleTwoTone/>  8-10 Dec 2024</p>
                            <a-divider class="mydivider" type="vertical" />
                            <p><EnvironmentTwoTone />  Hong Kong</p>
                        </div>
                        <router-link to="/registration">
                            <a-button class="mybutton" type="primary">Register Now</a-button>
                        </router-link>
                        
                    </div>
                </div>
                <div class="banner-media">
                    <ul>
                        <!-- <li><TwitterOutlined/></li> -->
                        <li><a href="https://x.com/carto20244259?s=21" target="_blank"><span class="iconfont icon-tuite"></span></a></li>
                        <li><a href="https://mp.weixin.qq.com/s/H9zpEGJzDHUhaaenfM-f3Q" target="_blank"><WechatOutlined/></a></li>
                        <li><a href="https://www.linkedin.com/in/asia-carto-1562342a8/" target="_blank"><LinkedinOutlined/></a></li>
                        <li><a href="https://www.facebook.com/profile.php?id=61554916307283" target="_blank"><FacebookOutlined/></a></li>
                        
                    </ul>
                </div>
            </div>
            
        </div>
        
    </div>
</template>

<script>
    import { ClockCircleTwoTone, EnvironmentTwoTone, WechatOutlined, LinkedinOutlined, FacebookOutlined} from '@ant-design/icons-vue';
    export default {
        components: {
            ClockCircleTwoTone,
            EnvironmentTwoTone,
            WechatOutlined,
            LinkedinOutlined,
            FacebookOutlined,
            
        },
    }
</script>

<style lang="less" scoped>
    @import "./style.less" ;
</style>